import Catalog from './Catalog/route';
import Products from './Products/route';
import Attributes from './Attributes/route';
import Shippers from './Shippers/shppers-route';
import Suppliers from './Suppliers/suppliers-route';
import SuppliedGoods from './SuppliedGoods/supplies-route';
import SuppliersGroup from './SupplierGroup/supplier-group-route';

const InventoryRoutes = [
  ...Catalog,
  ...Attributes,
  ...Shippers,
  ...SuppliersGroup,
  ...Suppliers,
  ...Products,
  ...SuppliedGoods,
];

export default InventoryRoutes;
